<script lang="tsx">
  import { defineComponent, PropType } from 'vue'
  import Icon from '@xhs/yam-beer/cmp/common/Icon/Icon.vue'
  import { GRID_32 } from '@xhs/yam-beer/cmp/constants/builtinIcon'
  import { StepStatus, BeerStepStatusType } from '@xhs/yam-beer/cmp/constants/StepStatus'

  export default defineComponent({
    name: 'BeerStepCircle',
    props: {
      status: {
        type: String as PropType<BeerStepStatusType>,
      },
      stepNo: {
        type: Number,
      },
      icon: {
        type: String,
      },
    },

    setup(props) {
      return () => {
        const { icon, status, stepNo } = props
        if (icon) {
          return (
          <Icon
            gridSize={24}
            size={16}
            icon={icon}
          />
        )
        }
        if (status === StepStatus.DONE) {
          return (
          <Icon
            gridSize={32}
            size={32}
            iconPath={GRID_32.DONE}
          />
        )
        }
        if (status === StepStatus.FAILED) {
          return (
          <Icon
            gridSize={32}
            size={32}
            iconPath={GRID_32.FAILED}
          />
        )
        }
        return stepNo
      }
    },
  })

</script>
